import { useMemo } from 'react'
import { ILegacyParserClassTypes, ILegacyBuilderClassTypes } from 'types/graphqlTypes'
import { useConfigurableBuilders } from '../../hooks/useConfigurableBuilders'
import { useConfigurableParsers } from '../../hooks/useConfigurableParsers'

export const useFormOptionsBuilders = () => {
  const { configurableParsers } = useConfigurableParsers()
  const { configurableBuilders } = useConfigurableBuilders()

  const noneOption = useMemo(() => {
    return { label: '-- none --', value: '' }
  }, [])

  const configurableParserOptions = useMemo(() => {
    const output = [noneOption]
    configurableParsers.forEach(parser => {
      output.push({
        label: parser.name,
        value: parser.id,
      })
    })
    return output
  }, [configurableParsers, noneOption])

  const configurableBuilderOptions = useMemo(() => {
    const output = [noneOption]
    configurableBuilders.forEach(builder => {
      output.push({
        label: builder.name,
        value: builder.id,
      })
    })
    return output
  }, [configurableBuilders, noneOption])

  const legacyParserOptions = useMemo(() => {
    const output = [noneOption]
    for (const key of Object.keys(ILegacyParserClassTypes)) {
      output.push({
        label: key,
        value: key,
      })
    }
    return output
  }, [noneOption])

  const legacyBuilderOptions = useMemo(() => {
    const output = [noneOption]
    for (const key of Object.keys(ILegacyBuilderClassTypes)) {
      output.push({
        label: key,
        value: key,
      })
    }
    return output
  }, [noneOption])

  return {
    configurableParserOptions,
    configurableBuilderOptions,
    legacyParserOptions,
    legacyBuilderOptions,
  }
}
